import Vue from 'vue'
import $ from 'jquery'
import SimulateurMensualites from './components/SimulateurMensualites.vue'
import SimulateurCapaciteEmprunt  from './components/SimulateurCapaciteEmprunt.vue'
import SimulateurCalculCreditImmobilier  from './components/SimulateurCalculCreditImmobilier.vue'
import SimulateurExpress  from './components/SimulateurExpress.vue'
import Cleave from 'vue-cleave-component'

Vue.use(Cleave)

export default {

  enable () {
   
    $('.simulateur-mensualite-vue').each((index, elem) => {
      const SimulateurMensualitesConstructor = Vue.extend(SimulateurMensualites)
      const vm = new SimulateurMensualitesConstructor({ }).$mount(elem)
    })

    $('.simulateur-capacite-emprunt-vue').each((index, elem) => {
      const SimulateurCapaciteEmpruntConstructor = Vue.extend(SimulateurCapaciteEmprunt)
      const vm = new SimulateurCapaciteEmpruntConstructor({ }).$mount(elem)
    })
    $('.simulateur-credit-immobilier-vue').each((index, elem) => {
      const SimulateurCalculCreditImmobilierConstructor = Vue.extend(SimulateurCalculCreditImmobilier)
      const vm = new SimulateurCalculCreditImmobilierConstructor({ }).$mount(elem)
    })
    $('.simulateur-express-vue').each((index, elem) => {
      const SimulateurExpressConstructor = Vue.extend(SimulateurExpress)
      const vm = new SimulateurExpressConstructor({ }).$mount(elem)
    })
 }
}


// WEBPACK FOOTER //
// ./src/js/vue/bootstrap.js